
import { EnumHelper } from "./enum.helper";



enum QuestionType {
    CheckBoxList = 0,
    Radio = 1,
    Checkbox = 2,
    YesNo = 3,
    Text = 4,
    Document = 5,
    None = 6,
    Acknowledgement = 7,
}
    
namespace QuestionType {
    var _textValues = {
        0: { textValue: "CheckBoxList", order: 0 },
        1: { textValue: "Radio", order: 1 },
        2: { textValue: "Checkbox", order: 2 },
        3: { textValue: "YesNo", order: 3 },
        4: { textValue: "Text", order: 4 },
        5: { textValue: "Document", order: 5 },
        6: { textValue: "None", order: 6 },
        7: { textValue: "Acknowledgement", order: 7 },
    };

    export function getTextValue(value:QuestionType){
        return _textValues[value].textValue; 
    }

    export function getValueList(sort?:boolean):Array<{id:number, label:string}>{
        return EnumHelper.getValueList(<any>_textValues, sort);
    }
}

export {QuestionType}





// WEBPACK FOOTER //
// ./enums/QuestionType.ts